import { Table } from "antd";
import { Loader } from "@vds/loaders";
import { searchTableRecordByInput } from "../../utility/tableUtils.js";
import "../../../../src/styles.css";
export const CustomTable = (props) => {
  const {
    className,
    dataList,
    tableLoading,
    handleChange,
    searchInputText,
    searchColumns,
    renderedColumns,
    rowClassName,
    onExpand,
    expandedRowKeys,
    locale,
    totalIncidentCount,
    itemsPerPage,
    showPagination,
    expandable,
  } = props;

  return (
    <>
      <div style={{ overflowX: "auto" }} className="sasp_custom-table-warpper">
        <Table
          className={`ant-table-tbody ${className || ""}`}
          onExpand={onExpand}
          rowClassName={rowClassName}
          rowKey={(record) => record.id}
          columns={renderedColumns}
          expandable={expandable}
          dataSource={
            !searchInputText || searchInputText === ""
              ? dataList
              : dataList.filter((device) =>
                  searchTableRecordByInput(
                    device,
                    searchInputText,
                    searchColumns,
                    dataList
                  )
                )
          }
          style={{ width: "100%", minWidth: "60%" }}
          onChange={handleChange}
          loading={false}
          pagination={
            showPagination
              ? {
                  pageSize: itemsPerPage,
                  total: totalIncidentCount,
                  showSizeChanger: false,
                }
              : false
          }
          locale={
            tableLoading
              ? { emptyText: <div className="table-loading-wrapper"><Loader active={true} fullscreen={false} surface="light" /></div> }
              : locale
          }
          expandedRowKeys={expandedRowKeys}
        />
      </div>
    </>
  );
};
